var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalitics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 30,
    height: 30,
    rx: 12,
    fill: "#1A1F37"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0468 24.5316H15.1093C14.9229 24.5316 14.744 24.4575 14.6122 24.3257C14.4803 24.1938 14.4062 24.015 14.4062 23.8285V19.6097C14.4062 19.4233 14.4803 19.2444 14.6122 19.1126C14.744 18.9807 14.9229 18.9066 15.1093 18.9066H16.0468C16.2333 18.9066 16.4122 18.9807 16.544 19.1126C16.6759 19.2444 16.75 19.4233 16.75 19.6097V23.8285C16.75 24.015 16.6759 24.1938 16.544 24.3257C16.4122 24.4575 16.2333 24.5316 16.0468 24.5316V24.5316Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6094 24.5308H21.6719C21.4854 24.5308 21.3065 24.4567 21.1747 24.3249C21.0428 24.193 20.9687 24.0142 20.9687 23.8277V16.7964C20.9687 16.61 21.0428 16.4311 21.1747 16.2992C21.3065 16.1674 21.4854 16.0933 21.6719 16.0933H22.6094C22.7959 16.0933 22.9747 16.1674 23.1066 16.2992C23.2384 16.4311 23.3125 16.61 23.3125 16.7964V23.8277C23.3125 24.0142 23.2384 24.193 23.1066 24.3249C22.9747 24.4567 22.7959 24.5308 22.6094 24.5308V24.5308Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8906 24.5312H24.9531C24.7666 24.5312 24.5878 24.4571 24.4559 24.3252C24.3241 24.1934 24.25 24.0145 24.25 23.828V13.5155C24.25 13.3291 24.3241 13.1502 24.4559 13.0184C24.5878 12.8865 24.7666 12.8124 24.9531 12.8124H25.8906C26.0771 12.8124 26.2559 12.8865 26.3878 13.0184C26.5196 13.1502 26.5937 13.3291 26.5937 13.5155V23.828C26.5937 24.0145 26.5196 24.1934 26.3878 24.3252C26.2559 24.4571 26.0771 24.5312 25.8906 24.5312V24.5312Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3281 24.531H18.3906C18.2041 24.531 18.0253 24.4569 17.8934 24.3251C17.7616 24.1932 17.6875 24.0144 17.6875 23.8279V11.1716C17.6875 10.9851 17.7616 10.8063 17.8934 10.6744C18.0253 10.5426 18.2041 10.4685 18.3906 10.4685H19.3281C19.5146 10.4685 19.6934 10.5426 19.8253 10.6744C19.9572 10.8063 20.0312 10.9851 20.0312 11.1716V23.8279C20.0312 24.0144 19.9572 24.1932 19.8253 24.3251C19.6934 24.4569 19.5146 24.531 19.3281 24.531V24.531Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_13",
    x: 0.5,
    y: -2.38419e-7,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_13",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalitics);
export default __webpack_public_path__ + "static/media/analitics.b3e5d84cc37927263f9d20cdea7c4cea.svg";
export { ForwardRef as ReactComponent };